export default "__VITE_ASSET__DelfCFs9__"